// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cartridge":"_3qsmH","gallery":"cFOBj","wrapper":"wav-v","imageSlider":"qWa0T"};